// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form-leave-confirm-modal_wrapper_WDxhE","submit":"form-leave-confirm-modal_submit_3Yqx0","subIcon":"form-leave-confirm-modal_subIcon_2mwn1"};